import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { Customer } from "../shared/models/customer";
import { DataStoreService } from "../shared/services/api/data-store.service";

@Injectable()
export class CustomerResolverService implements Resolve<Customer> {
  constructor(private dataStore: DataStoreService,
              private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    let id = route.params['id'];
    if (id) {
      return this.dataStore.findRecord(Customer, id);
    } else {
      return true;
    }

  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/customer/customer-resolver.service.ts